import React from "react";
import styled, {css, keyframes} from "styled-components";
import {media} from "../../../../theme/responsive";
import ULP_Sprite from "../../../../images/ULP_Sprite.svg";
import {validateField} from "../../../../utils/validation";
import {Link} from "react-router-dom";

export const LinkDiv = styled.div`
    width: 100%;
    line-height: 20px;
    margin-bottom: 5px;
    ${media.laptop`margin-bottom:8px;`}
    &:last-child {
        margin: 0;
    }
`;

const sharedStyleAnchor = css`
    position: ${(props) => (props.enableRipple ? "relative" : "")};
    font-size: ${(props) => {
        if (validateField(props, "object", "displaystyle.mobile.fontSize"))
            return props.displaystyle.mobile.fontSize;
        return "";
    }};
    margin-top: ${(props) => {
        if (validateField(props, "object", "displaystyle.mobile.marginTop"))
            return props.displaystyle.mobile.marginTop;
        return "";
    }};

    text-align: ${(props) => {
        if (validateField(props, "object", "displaystyle.mobile.textAlign"))
            return props.displaystyle.mobile.textAlign;
        return "";
    }};
    vertical-align: ${(props) => {
        if (validateField(props, "object", "displaystyle.mobile.verticalAlign"))
            return props.displaystyle.mobile.verticalAlign;
        return "middle";
    }};
    display: ${(props) => {
        if (validateField(props, "object", "displaystyle.mobile.display"))
            return props.displaystyle.mobile.display;
        return "inline-block";
    }};
    max-width: ${(props) => {
        if (validateField(props, "object", "displaystyle.mobile.maxWidth"))
            return props.displaystyle.mobile.maxWidth;
        return "88%";
    }};
    width: ${(props) => {
        if (validateField(props, "object", "displaystyle.mobile.width")) {
            if (props.debug) console.log("hello");
            return props.displaystyle.mobile.width;
        }

        return "auto";
    }};
    text-overflow: ${(props) => {
        if (validateField(props, "object", "displaystyle.mobile.textOverflow"))
            return props.displaystyle.mobile.textOverflow;
        return "unset";
    }};
    font-weight: ${(props) => {
        if (validateField(props, "object", "displaystyle.mobile.fontWeight"))
            return props.displaystyle.mobile.fontWeight;
        return "400";
    }};
    white-space: ${(props) => {
        if (validateField(props, "object", "displaystyle.mobile.whiteSpace"))
            return props.displaystyle.mobile.whiteSpace;
        return "unset";
    }};
    pointer-events: ${(props) => {
        if (validateField(props, "object", "displaystyle.mobile.pointerEvents"))
            return props.displaystyle.mobile.pointerEvents;
        return "unset";
    }};
    overflow: hidden;
    cursor: pointer;

    ${media.laptop`
    
font-weight: ${(props) => {
        if (validateField(props, "object", "displaystyle.laptop.fontWeight"))
            return props.displaystyle.laptop.fontWeight;
        return "";
    }};                    
font-size: ${(props) => {
        if (validateField(props, "object", "displaystyle.laptop.fontSize"))
            return props.displaystyle.laptop.fontSize;
        return "";
    }};    
margin-top:${(props) => {
        if (validateField(props, "object", "displaystyle.laptop.marginTop"))
            return props.displaystyle.laptop.marginTop;
        return "";
    }};   
text-align:${(props) => {
        if (validateField(props, "object", "displaystyle.laptop.textAlign"))
            return props.displaystyle.laptop.textAlign;
        return "";
    }};  
vertical-align:${(props) => {
        if (validateField(props, "object", "displaystyle.laptop.verticalAlign"))
            return props.displaystyle.laptop.verticalAlign;
        return "middle";
    }};         
width:${(props) => {
        if (validateField(props, "object", "displaystyle.laptop.width"))
            return props.displaystyle.laptop.width;
        return "auto";
    }};
max-width:${(props) => {
        if (validateField(props, "object", "displaystyle.laptop.maxWidth"))
            return props.displaystyle.laptop.maxWidth;
        return "88%";
    }};    
display:${(props) => {
        if (validateField(props, "object", "displaystyle.laptop.display"))
            return props.displaystyle.laptop.display;
        return "inline-block";
    }};  
text-overflow:${(props) => {
        if (validateField(props, "object", "displaystyle.laptop.textOverflow"))
            return props.displaystyle.laptop.textOverflow;
        return "unset";
    }};  
 white-space:${(props) => {
     if (validateField(props, "object", "displaystyle.laptop.whiteSpace"))
         return props.displaystyle.laptop.whiteSpace;
     return "unset";
 }};  
 pointer-events:${(props) => {
     if (validateField(props, "object", "displaystyle.laptop.pointerEvents"))
         return props.displaystyle.laptop.pointerEvents;
     return "unset";
 }};              
 
 `}
    &:after {
        content: ${(props) => props.after};
        ${(props) => {
            if (props.after === "''") {
                return `
            border: solid #1048c3;
            border-width: 0 2px 2px 0;
            font-size: 20px;
            display: inline-block;
            font-weight: 600;
            line-height: 31px;
            width: 6px;
            height: 6px;
            transform: rotate(-45deg);
            top: 0px;
            position: relative;
            left: 2px;
          `;
            }
        }}
    }
`;

export const AnchorStyle = styled.a`
    ${sharedStyleAnchor}
`;
export const LinkStyle = styled((props) => {
    // eslint-disable-next-line no-unused-vars
    const {displaystyle, forwardRef, enableRipple, ...rest} = props;
    return <Link sa="int" innerRef={forwardRef} {...rest} />;
})`
    ${sharedStyleAnchor}
`;

export const AnchorArrow = styled.span`
    background: url(${ULP_Sprite}) no-repeat;
    background-position: -64px -47px;
    width: 16px;
    height: 14px;
    display: inline-block;
    position: relative;
    top: 0px;
    left: 2px;
    vertical-align: middle;
    cursor: pointer;
    ${media.laptop`top:0px;`}
`;

export const rippleAnimation = keyframes`
  100% {
    transform: scale(2);
    opacity: 0;
  }
`;

export const RippleItem = styled.div`
    position: absolute;
    left: ${(props) => `${props.position.x}px`};
    top: ${(props) => `${props.position.y}px`};
    width: ${(props) => `${props.size}px`};
    height: ${(props) => `${props.size}px`};
    background: ${(props) => props.color || "rgba(0,0,0,0.2)"};
    border-radius: 50%;
    user-select: none;
    pointer-events: none;
    transform: scale(0);
    opacity: 0.7;
    animation: ${rippleAnimation} ${(props) => props.rippleDuration}ms linear;
`;
